// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'alertService' implicitly has an 'any' t... Remove this comment to see the full error message
const SummonAlert = (alertService, translationService) => ({
   templateUrl: '/assets/summonAlert.html',

   scope: {
      alertName: '@',
      retryAction: '&',
      translationParams: '=?'
   },

   compile() {
      return {
         pre(s: any) {
            s.alerts = alertService.alerts
            if (!s.translationParams) { s.translationParams = {} }
            return s.i18n = translationService
         },
         post(s: any, el: any, attrs: any) {
            if (attrs.closeButton != null) {
               s.closeable = true
               return s.close = () => alertService.resetAlert(s.alertName)
            }
         }
      }
   }
})

angular.module('summonApp.directives')
   .directive('summonAlert', ['alertService', 'translationService', SummonAlert])
